import { Link, useLocation } from 'react-router-dom';

const SUBNAV_ITEMS = [
  { label: 'New', to: '/shop/tees/new-designs' },
  { label: 'Men', to: '/shop/tees/men' },
  { label: 'Women', to: '/shop/tees/women' },
  { label: 'Kids', to: '/shop/tees/kids' },
  { label: 'Hats', to: '/shop/tees/caps' },
  { label: 'Sale', to: '/shop/tees/sale' }
];

function TeesSubNav() {
  const location = useLocation();

  return (
    <div style={{ background: '#1a1a1a' }}>
      <nav
        style={{
          maxWidth: '1200px',
          margin: '0 auto',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          gap: '36px',
          padding: '14px 20px',
          flexWrap: 'wrap'
        }}
      >
        {SUBNAV_ITEMS.map(item => {
          const isActive = location.pathname === item.to;
          const isSale = item.label === 'Sale';
          return (
            <Link
              key={item.to}
              to={item.to}
              style={{
                color: isSale ? '#f5a762' : (isActive ? '#fff' : '#bbb'),
                textDecoration: 'none',
                fontSize: '13px',
                fontWeight: isActive ? '700' : '500',
                letterSpacing: '1.5px',
                textTransform: 'uppercase',
                borderBottom: isActive ? '2px solid currentColor' : '2px solid transparent',
                paddingBottom: '4px',
                transition: 'color 0.2s'
              }}
            >
              {item.label}
            </Link>
          );
        })}
      </nav>
    </div>
  );
}

export default TeesSubNav;
